import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, onMounted, watch } from "vue";
import { IRelationshipService, RelationshipType } from '@truckdown/systems';
import { IAccountData } from '@truckdown/accounts';

interface IData {
    accountList: Ref<ISelectItem[]>,
    accountListUnfiltered: Ref<ISelectItem[]>,
    selectedAccount: Ref<ISelectItem | null>,
    showAccountList: Ref<boolean>,
    searchTermAccount: Ref<string>,
    accountNumber: Ref<string>,
};

export interface ISelectItem {
    value: string,
    display: string,
    terms?: string
};

const getInitialData = function (props: any) {
    return {
        accountList: ref<ISelectItem[]>([]),
        accountListUnfiltered: ref<ISelectItem[]>([]),
        selectedAccount: ref<ISelectItem | null>(null),
        showAccountList: ref<boolean>(false),
        searchTermAccount: ref<string>(""),
        accountNumber: ref<string>("")
    }
};

const getMethods = function (props: any, data: IData, ctx: any) {

    return {
        selectAccount: function (account?: ISelectItem) {
            let index;
            if (props.index != undefined || props.index != null) {
                index = props.index
            } else {
                index = null;
            }

            if (account) {
                data.selectedAccount.value = account;
                ctx.emit('select-account', account, index);
            } else {
                data.selectedAccount.value = null;
                ctx.emit('select-account', null, index);
            }

            data.searchTermAccount.value = "";
            data.showAccountList.value = false;
        }
    }
}


const getAccountInfo = async function (data: IData, id?: string) {
    if (id) {
        try {
            let accountSummary = await context.getService<IAccountData>('IAccountData');
            let accInfo = await accountSummary.getAccountInfo(id)
            data.selectedAccount.value = {
                value: accInfo?.id || "",
                display: accInfo?.ain + ' - ' + accInfo?.n,
                terms: accInfo?.ain.toString()
            };
            return accInfo;
        } catch {
            console.error("Error getting accountSummary");
        }
    }
    return {
        ain: "",
        id: ""
    }
}

const getAccounts = async function (data: IData) {
    let mgr = await context.getService<IRelationshipService>('IRelationshipService');
    await mgr.search({
        tags: data.searchTermAccount.value || '',
        type: RelationshipType.Account,
        limit: 15,
        desc: false
    })
        .then((res) => {
            data.accountList.value = res.results.map(r => ({
                value: r.accountId,
                display: r.display,
                terms: r.id
            }));
            data.accountListUnfiltered.value = data.accountList.value;
        })
        .catch((reason) => {
            console.log(reason);
        });
}

export default defineComponent({
    name: "AccountLookup",
    props: {
        accountId: {
            type: String,
            required: false
        },
        hideLabel: {
            type: Boolean,
            required: false
        },
        index: Number,
        disable: {
            type: Boolean,
            required: false
        }
    },
    emits: ['select-account'],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);

        onMounted(async () => {
            if (props.accountId) {
                let accountInfo = await getAccountInfo(data, props.accountId);
                data.accountNumber.value = accountInfo?.ain.toString() || "";
            }
        });

        watch(() => data.searchTermAccount.value, (newVal, oldVal) => {
            if (newVal !== oldVal) {
                if (newVal.length > 0) {
                    getAccounts(data);
                } else {
                    data.accountList.value = data.accountListUnfiltered.value;
                }
            }
        });

        return {
            ...data,
            ...methods
        };
    }
});
